<!-- 新增 / 编辑 游学 -->
<template>
  <div class="apply">
    <back />

    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
      <div class="form">
        <!-- <div class="title">基础信息：</div> -->
        <!-- 图片 -->
        <div class="container">
          <el-row class="dialog_row">
            <el-form-item class="item logo_pic" label="封面图片：" prop="coursePic1">
              <div class="pic-row">
                <div class="pic" v-for="(pic, index) in 3" :key="index">
                  <el-upload class="logo_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action"
                    :show-file-list="false" :on-success="res => handleSuccess(res, 'coursePic', index)"
                    :before-upload="beforeUploads" :on-remove="() => handleRemove('coursePic', index)"
                    :disabled="ruleForm[`coursePic${index + 1}`] ? true : false">
                    <img v-if="ruleForm[`coursePic${index + 1}`]" :src="ruleForm[`coursePic${index + 1}`]"
                      class="logoimg" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <i v-if="ruleForm[`coursePic${index + 1}`]" class="delpic el-icon-error"
                    :class="'delpic' + (index + 1)" @click="() => handleRemove('coursePic', index)"></i>
                </div>
              </div>
            </el-form-item>
          </el-row>
        </div>
        <div class="container">
          <el-form-item class="item" label="游学名称：" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="item" label="游学分类：" prop="categoryId">
            <el-cascader :options="categoryOptions" placeholder="选择分类" v-model="ruleForm.categoryId"
              :props="cascaderprops" collapse-tags clearable @change="handleSelectCategory"></el-cascader>
          </el-form-item>
          <el-form-item class="item" label="带队老师：" prop="teacherId">
            <el-select v-model="ruleForm.teacherId" placeholder="请选择" clearable @change="handleSelectTeacher">
              <el-option v-for="item in teacherNameOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="item" label="游学时间：" prop="time">
            <el-date-picker v-model="ruleForm.time" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" clearable value-format="yyyy-MM-dd"
              :picker-options="datePickerOptions"></el-date-picker>
          </el-form-item>
          <el-form-item class="item" label="人数：" prop="peopleCount">
            <el-input v-model="ruleForm.peopleCount" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="item" label="售价（元）：" prop="price">
            <el-input v-model="ruleForm.price" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="item" label="标签：" prop="label">
            <el-select v-model="ruleForm.label" placeholder="请选择标签" clearable>
              <el-option v-for="item in recommendOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="item" label="排序：" prop="sort">
            <el-input v-model="ruleForm.sort" placeholder="请输入"></el-input>
          </el-form-item>

        </div>
        <div class="title">详情介绍:</div>
        <div class="container">
          <el-form-item class="" label="" prop="introduce" label-width="80px">
            <editor :htmls="ruleForm.introduce" @change="onChange" />
          </el-form-item>
        </div>
        <div class="submit-btn">
          <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import editor from "@/components/editor.vue"
export default {
  components: {
    editor
  },
  data() {
    return {
      datePickerOptions: {
        disabledDate: (time) => {
          // 限制只能选择今天及以后的日期
          return time.getTime() < new Date().setHours(0, 0, 0, 0);
        }
      },
      recommendOptions: [
        {
          label: '最新',
          value: 1
        },
        {
          label: '热门',
          value: 2
        },
        {
          label: '推荐',
          value: 3
        },
      ],
      cascaderprops: {
        checkStrictly: false,
        emitPath: false,
        value: "id",
        label: "categoryName",
        children: "children",
      },
      categoryOptions: [], // 分类options
      teacherNameOptions: [], // 专家options
      ruleForm: {
        coursePic1: "",
        coursePic2: "",
        coursePic3: "",

        name: '',
        categoryName: '',
        categoryId: '',
        teacherId: '',
        time: '',
        peopleCount: '',
        price: '',
        introduce: '',
        sort: '',
      },
      rules: {
        coursePic1: [
          { required: true, message: "请上传封面图片", trigger: "blur" }
        ],
        name: [{
          required: true,
          message: '请输入游学名称',
          trigger: 'blur'
        }],
        categoryId: [{
          required: true,
          message: '请选择游学分类',
          trigger: 'blur'
        }],
        teacherId: [{
          required: true,
          message: '请选择带队老师',
          trigger: 'blur'
        }],
        time: [{
          required: true,
          message: '请选择游学时间',
          trigger: 'blur'
        }],
        price: [{
          required: true,
          message: '请输入课程价格',
          trigger: 'blur'
        }, {
          pattern: /^\d+(\.\d{1,2})?$/,
          message: '只能输入数字',
          trigger: 'blur'
        }],
        peopleCount: [{
          required: true,
          message: '请输入人数',
          trigger: 'blur'
        }, {
          pattern: /^[1-9]\d*$/,
          message: '只能输入正整数',
          trigger: 'blur'
        }],
        sort: [{
          pattern: /^[1-9]\d*$/,
          message: '只能输入正整数',
          trigger: 'blur'
        }],
      },
      // 图片上传
      action: this.$axios.defaults.baseURL + this.$api.uploadFile,
      headers: {
        token: this.$store.state.token,
      },
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.id) {
      to.meta.title = "编辑游学";
    } else {
      to.meta.title = "新增游学";
    }
    next();
  },
  mounted() {
    document.title = this.$route.meta.title;
  },
  watch: {
    '$route'(to, from) {
      document.title = to.meta.title;
    },
  },
  created() {
    this.getCategoryList()
    this.selectListByTeacher()
    if (this.$route.query.id) {
      this.selectStudyTourInfoDetail()
    }
  },

  methods: {
    onChange(value) {
      this.ruleForm.introduce = value
    },
    // 分类
    getCategoryList() {
      this.$axios
        .get(this.$api.getStudyTourCategoryPage, {
          params: {
            page: 1,
            pageSize: 9999,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.categoryOptions = res.result.list
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    handleSelectCategory(value) {
      this.$set(this.ruleForm, "categoryId", value)
    },
    selectListByTeacher() {
      this.$axios
        .get(this.$api.selectListByTeacher)
        .then(res => {
          if (res.code == 100) {
            this.teacherNameOptions = res.result.map(item => {
              return {
                label: item.teacherName,
                value: item.id
              }
            })
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    handleSelectTeacher(value) {
      const selectedTeacher = this.teacherNameOptions.find(item => item.value === value);
      if (selectedTeacher) {
        this.ruleForm.teacherName = selectedTeacher.label;
      }
    },
    selectStudyTourInfoDetail() {
      this.$axios.get(this.$api.selectStudyTourInfoDetail, {
        params: { id: this.$route.query.id }
      }).then(res => {
        if (res.code === 100) {
          const row = res.result;
          this.ruleForm = {
            name: row.name,
            categoryId: row.categoryId,
            categoryName: row.categoryName,
            teacherId: row.teacherId,
            teacherName: row.teacherName,
            time: [],
            peopleCount: row.peopleCount,
            price: row.price,
            introduce: row.introduce,
            sort: row.sort,
            label: row.label,
            coursePic1: row.pictureList?.[0] || '',
            coursePic2: row.pictureList?.[1] || '',
            coursePic3: row.pictureList?.[2] || ''
          };

          if (row.startTime && row.endTime) {
            this.ruleForm.time = [row.startTime, row.endTime];
          }
          this.$set(this.ruleForm, 'time', this.ruleForm.time);
          this.$set(this.ruleForm, 'peopleCount', this.ruleForm.peopleCount);
          this.$set(this.ruleForm, 'coursePic1', this.ruleForm.coursePic1);
          this.$set(this.ruleForm, 'coursePic2', this.ruleForm.coursePic2);
          this.$set(this.ruleForm, 'coursePic3', this.ruleForm.coursePic3);
          this.$set(this.ruleForm, 'categoryId', row.categoryId);
        }
      }).catch(err => {
        this.$message.error(err.desc);
      });
    },
    // 表单校验
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {

          const formData = {
            categoryId: this.ruleForm.categoryId,
            name: this.ruleForm.name,
            introduce: this.ruleForm.introduce,
            price: this.ruleForm.price,
            // teacherName: this.ruleForm.teacherName || null,
            teacherId: this.ruleForm.teacherId,
            sort: this.ruleForm.sort,
            label: this.ruleForm.label,
            peopleCount: this.ruleForm.peopleCount,
            pictureList: [this.ruleForm.coursePic1, this.ruleForm.coursePic2, this.ruleForm.coursePic3].filter(Boolean),
            startTime: this.ruleForm.time[0],
            endTime: this.ruleForm.time[1],
          }
          if (this.$route.query.id) {
            // 如果存在 this.$router.query.id
            formData.id = this.$route.query.id
            this.$axios
              .post(this.$api.updateStudyTourInfo, formData)
              .then(res => {
                if (res.code == 100) {
                  this.$message.success(res.desc)
                  this.$router.go(-1)
                  this.resetForm()
                }
              })
              .catch(err => {
                this.$message.error(err.desc)
              })
          } else {
            // 否则调用添加接口 =
            this.$axios
              .post(this.$api.insertStudyTourInfo, formData)
              .then(res => {
                if (res.code == 100) {
                  this.$message.success(res.desc)
                  this.$router.go(-1)
                  this.resetForm()
                }
              })
              .catch(err => {
                this.$message.error(err.desc)
              })
          }
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    // 重置表单
    resetForm() {
      this.ruleForm = {}
      this.$refs.ruleForm.resetFields()
    },
    beforeUploads(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/png"
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!")
      }
      return isJPG
    },

    handleRemove(picType, index) {
      const tempObj = { ...this.ruleForm }
      this.ruleForm = null
      this.ruleForm = { ...tempObj }
      this.$set(this.ruleForm, `${picType}${index + 1}`, "")
    },

    handleSuccess(res, picType, index) {
      if (res.code === 100) {
        const tempObj = { ...this.ruleForm }
        this.ruleForm = null
        this.ruleForm = { ...tempObj }
        this.$set(this.ruleForm, `${picType}${index + 1}`, res.result.fileUrl)
      } else {
        this.$message.error(res.desc)
      }
    }
  },
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
.form {
  margin: 30px 20px;

  .title {
    font-size: 18px;
    margin-left: 60px;
    padding-bottom: 15px;
    padding-left: 20px;
    margin-bottom: 10px;
    font-weight: bold;
    border-bottom: 1px solid #E5E7E6;
  }

  .container {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 30px;
    font-size: 16px;
    color: #707070;

    ::v-deep .el-form-item__label {
      color: #272727;
      font-size: 16px;
      padding-right: 15px;
    }

    .el-input,
    .el-select,
    .el-cascader,
    .el-date-editor {
      width: 300px;
    }

    .el-input-number {
      width: 300px;

      ::v-deep .el-input-number__decrease {
        border-radius: 10px 0 0 10px !important;
      }

      ::v-deep .el-input-number__increase {
        border-radius: 0 10px 10px 0 !important;
      }
    }
  }

  .item {
    width: 30%;
    /* 100% / 3 = 33.33%，留一点空间避免浏览器计算误差 */
    margin-bottom: 30px;
    margin-right: 30px;
  }

  .container .item:nth-last-child(-n+3) {
    margin-bottom: 0;
  }
}

.submit-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 100px;
}


/* 商品图片上传样式 */
.logo_pic {
  position: relative;

  ::v-deep.el-form-item__content {
    width: 100px;
    height: 100px;
  }

  .pic-row {
    display: flex;

    .pic {
      margin-right: 15px;

      .logo_uploader {
        ::v-deep .el-upload {
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        ::v-deep .el-upload:hover {
          border-color: $themes;
        }

        .avatar-uploader-icon {
          font-size: 28px;
          color: $themes;
          width: 100px;
          height: 100px;
          line-height: 100px;
          text-align: center;
        }

        .logoimg {
          width: 100px;
          height: 100px;
          display: block;
          object-fit: cover;
        }
      }
    }
  }

  .delpic {
    position: absolute;
    top: -12px;
    color: red;
    font-size: 20px;
    cursor: pointer;
  }

  .delpic1 {
    left: 90px;
  }

  .delpic2 {
    left: 210px;
  }

  .delpic3 {
    left: 325px;
  }
}
</style>
